export default __webpack_public_path__ + "assets/images/button-thumb-up.66e1fa0789bbff410443cd76fb8307fb.svg";